import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Page } from 'src/common/routes';
import { LazyImage } from 'src/components/common';
import MobileHeaderMenu from '../MobileHeaderMenu';

const MobileHeaderContainer = styled.header`
  width: 95%;
  height: 74px;
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 110px;
  backdrop-filter: blur(90px);
  display: none;
  
  @media (min-width: 986px) {
    display: none !important;
  }

  @media (max-width: 987px) {
    display: block;
  }
`;

const HeaderContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  width: 120px;
`;

const LogoImage = styled.img`
  width: 100%;
`;

const HamburgerButton = styled.button`
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HamburgerIcon = () => (
  <svg width="26.67" height="20" viewBox="0 0 26.67 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1H26.67" stroke="#211747" strokeWidth="2"/>
    <path d="M0 10H26.67" stroke="#211747" strokeWidth="2"/>
    <path d="M0 19H26.67" stroke="#211747" strokeWidth="2"/>
  </svg>
);

const MobileHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <MobileHeaderContainer>
        <HeaderContent>
          <LogoContainer>
            <Link to={`/${Page.Home}`}>
              <LazyImage
                src="/images/Logo.svg"
                alt="Kymera Logo"
                width={120}
                height={36}
              />
            </Link>
          </LogoContainer>
          <HamburgerButton onClick={toggleMenu}>
            <HamburgerIcon />
          </HamburgerButton>
        </HeaderContent>
      </MobileHeaderContainer>
      <MobileHeaderMenu isOpen={isMenuOpen} onClose={toggleMenu} />
    </>
  );
};

export default MobileHeader; 